import { createRouter, createWebHashHistory } from 'vue-router';
import Login from '@/views/Login.vue';
import Companies from '@/views/Companies.vue';
import Groups from '@/views/Groups.vue';

const router = createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Companies
        },
        {
            path: '/companies',
            name: 'Companies',
            component: Companies
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/groups',
            name: 'Groups',
            component: Groups
        }
    ]
});

export default router;
